module.exports = __webpack_public_path__ + "static/stock-image-30-min-788463b89ccc38dd9c06e5b7ca972702.jpg";